const BetaBadge = () => (
  <span className="bg-lavendar-100 text-lavendar-600 ml-2 px-1.5 py-0.5 rounded-[8px] leading-5 prose-p4">
    <b>Beta</b>
  </span>
)

export default BetaBadge
